import React from "react";
import { Link } from "react-router-dom";
var bg = "./Asserts/dash-bg.png";

const NavBar = () => {
  const pathName = window.location.pathname;
  return (
    <nav
      style={{
        backgroundImage: `  url(${bg})`,
      }}
      id="sidebar"
    >
      <div className="sidebar-header text-center">
        <img src="../Asserts/chesscoin.png" className="img-fluid" alt="" />
        <img src="../Asserts/logo.png" className="img-fluid logo mt-3" alt="" />
      </div>

      <ul className="list-unstyled components">
        <li className={pathName === "/" ? "active" : ""}>
          <Link to="./">
            <img
              src="../Asserts/sidebar-icon.svg"
              className="img-fluid"
              alt=""
            />{" "}
            <br />
            App
          </Link>
        </li>
        <li className={pathName === "/dashtreasury" ? "active" : ""}>
          <Link to="./dashtreasury">
            {" "}
            <img
              src="../Asserts/sidebar-icon.svg"
              className="img-fluid"
              alt=""
            />{" "}
            <br />
            Treasury
          </Link>
        </li>
        <li className={pathName === "/dashcommunity" ? "active" : ""}>
          <Link to="./dashcommunity">
            {" "}
            <img
              src="../Asserts/sidebar-icon.svg"
              className="img-fluid"
              alt=""
            />{" "}
            <br />
            Community
          </Link>
        </li>
        <li>
          <a
            href="https://kingdoms-financial.gitbook.io/kingdoms-financial/the-basics/2-rewards-and-taxes"
            target="_blank"
          >
            {" "}
            <img
              src="../Asserts/sidebar-icon.svg"
              className="img-fluid"
              alt=""
            />{" "}
            <br />
            Info
          </a>
        </li>
      </ul>

      <div className="sidebar-socialicon">
        <div style={{ margin: "20px" }} className="row justify-content-around">
          <a href="https://kingdoms-financial.herokuapp.com/" target="_blank">
            <img src="../Asserts/Home.svg" className="img-fluid" alt="" />
          </a>
          <a href="https://twitter.com/Kingdoms_fi" target="_blank">
            <img src="../Asserts/Twitter.svg" className="img-fluid" alt="" />
          </a>
          <a href="https://discord.gg/Bs75vtPac2" target="_blank">
            <img src="../Asserts/Discord.svg" className="img-fluid" alt="" />
          </a>
        </div>
        <h6>
          Alpha Version <br /> 0.0.1
        </h6>
      </div>
    </nav>
  );
};

export default NavBar;
